import { FallbackError } from "@core/domain/errors/fallback.error";
import type { Nullable } from "@core/domain/types/nullable.type";
import { NotebookDatasource } from "@notebook/data/datasources/notebook.datasource";
import type { Notebook } from "@notebook/domain/models/notebook.model";
import type { NotebookRepository } from "@notebook/domain/repositories/notebook.repository";
import { inject, injectable } from "inversify";
import type { ResultAsync } from "neverthrow";

@injectable()
export class NotebookImplRepository implements NotebookRepository {
    constructor(
        @inject(NotebookDatasource)
        private readonly notebookDatasource: NotebookDatasource,
    ) {}

    fetchById(
        notebookId: string,
    ): ResultAsync<Nullable<Notebook>, FallbackError> {
        return this.notebookDatasource.fetchById(notebookId);
    }
}
